import React, { useEffect, useState, useRef } from 'react';
import { Button, Form, Input, ConfigProvider, Modal, Table, message, Select, Tag, Space } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
import { hnrequest } from '@/utils'
import zhCN from 'antd/locale/zh_CN';

const Uauthmg = () => {
    const [messageApi, contextHolder] = message.useMessage();
    const [open, setOpen] = useState(false);

    const [tabm, settabm] = useState([]);
    const [ztv, setZtv] = useState(0);

    const [uadd] = Form.useForm();

    useEffect(() => {
        async function getau() {
            const res2 = await hnrequest.post('/p_uauth')
            settabm(res2.rescode)
        }

        getau()

    }, [ztv])

    const onFinish = async (value) => {
        setOpen(false)
        const rzs = await hnrequest.post('/p_uadd_auth', value)
        messageApi.open({
            type: rzs.return_code,
            content: rzs.return_msg,
        })
        setZtv(rzs.ticks)

    };



    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const searchInput = useRef(null);
    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };
    const handleReset = (clearFilters) => {
        clearFilters();
        setSearchText('');
    };
    const getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
            <div
                style={{
                    padding: 8,
                }}
                onKeyDown={(e) => e.stopPropagation()}
            >
                <Input
                    ref={searchInput}
                    placeholder={`检索内容`}
                    value={selectedKeys[0]}
                    onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{
                        marginBottom: 8,
                        display: 'block',
                    }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{
                            width: 90,
                        }}
                    >
                        检索
                    </Button>
                    <Button
                        onClick={() => clearFilters && handleReset(clearFilters)}
                        size="small"
                        style={{
                            width: 90,
                        }}
                    >
                        重置
                    </Button>

                    <Button
                        type="link"
                        size="small"
                        onClick={() => {
                            close();
                        }}
                    >
                        关闭
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: (filtered) => (
            <SearchOutlined
                style={{
                    color: filtered ? '#1677ff' : undefined,
                }}
            />
        ),
        onFilter: (value, record) =>
            record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
        filterDropdownProps: {
            onOpenChange(open) {
                if (open) {
                    setTimeout(() => searchInput.current?.select(), 100);
                }
            },
        },
        render: (text) =>
            searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{
                        backgroundColor: '#ffc069',
                        padding: 0,
                    }}
                    searchWords={[searchText]}
                    autoEscape
                    textToHighlight={text ? text.toString() : ''}
                />
            ) : (
                text
            ),
    });


    const columns = [
        {
            title: <Button type="primary" onClick={() => { setOpen(true) }}>添加</Button>,
            key: 'action',
            dataIndex: 'dtime',
            ...getColumnSearchProps('dtime'),
        },
        {
            title: '商户编号',
            dataIndex: 'fsh_id',
            key: 'fsh_id',
            ...getColumnSearchProps('fsh_id'),
        },
        {
            title: '标签',
            key: 'tags',
            ...getColumnSearchProps('tags'),
            dataIndex: 'tags',
            render: (_, { tags }) => (
                <>
                    {tags && tags.map((tag) => {
                        let color = tag.length > 5 ? 'geekblue' : 'green';
                        if (tag === 'loser') {
                            color = 'volcano';
                        }
                        return (
                            <Tag color={color} key={tag}>
                                {tag.toUpperCase()}
                            </Tag>
                        );
                    })}
                </>
            ),
        },


    ];




    return <ConfigProvider locale={zhCN}>
        <>{contextHolder}


            <Table columns={columns} dataSource={tabm} key='qyrztab' />

            <Modal
                title="添加授权"
                centered
                open={open}
                footer={null}

                onCancel={() => setOpen(false)}
                width={800}
            >
                <Form
                    name="uadd"
                    labelCol={{
                        flex: '110px',
                    }}
                    labelAlign="left"
                    labelWrap
                    wrapperCol={{
                        flex: 1,
                    }}
                    colon={false}
                    style={{
                        maxWidth: 600,
                    }}
                    form={uadd}
                    onFinish={onFinish}
                >
                    <Form.Item
                        label="商户编号"
                        name="fsh_id" key="fsh_id"
                        rules={[
                            { required: true, message: '请填写要授权的商户编号！' },
                            { pattern: /^[0-9]+$/, message: '商户编号为纯数字!' }
                        ]}
                    >
                        <Input placeholder='请填写要授权的商户编号！' />
                    </Form.Item>

                    <Form.Item
                        label="备注标签"
                        name="tags" key="tags"
                        rules={[
                            {
                                required: true, message: '请填写正确的公司账户！'
                            },
                        ]}
                    >
                        <Select
                            mode="tags"
                            style={{
                                width: '100%',
                            }}
                            tokenSeparators={[',']}
                            placeholder='简称或者公司名称，方便查询，不对外展示'
                        />
                    </Form.Item>
                    <Form.Item label=" " key='tsubbutton'>
                        <Button type="primary" block={true} htmlType="submit">
                            提交
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>










        </>

    </ConfigProvider>


}

export default Uauthmg